module.exports = __webpack_public_path__ + "img/Mathematics.4a289e43.jpg";